(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureDetailController', ApplicationFeatureDetailController);

    ApplicationFeatureDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ApplicationFeature'];

    function ApplicationFeatureDetailController($scope, $rootScope, $stateParams, entity, ApplicationFeature) {
        var vm = this;

        vm.applicationFeature = entity;

        var unsubscribe = $rootScope.$on('portalApp:applicationUpdate', function(event, result) {
            vm.applicationFeature = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
